import { Box, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { FC } from 'react'
import { useColorModeContext } from '../../context/ColorModeContext'

interface CountryProps {
  country: string;
  language: string;
}

interface FlagSelectorProps {
  countries: CountryProps[];
  onChange: (selectedCountry: CountryProps) => void;
  value?: CountryProps;
  width?: number;
  label?: string;
}

const FlagSelector: FC<FlagSelectorProps> = ({
  countries,
  onChange,
  value,
  width = 24
}) => {
  const { t } = useTranslation()
  const { mode } = useColorModeContext()

  const renderValue = (selectedValue: string) => {
    if (!selectedValue) {
        return '';
    }
    const selected = JSON.parse(selectedValue) as CountryProps;
    const country = countries.find(c => c.country === selected.country && c.language === selected.language);
    if (!country) return '';
    return (
      <>
        <Box position={'absolute'} top={-18} left={0}>
          <Typography fontSize={12} style={{ color: '#6C7380' }}>{t(`language.${selected.language}`)}</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <img
            src={`https://flagcdn.com/${country.country.toLowerCase()}.svg`}
            width={width}
            style={{ marginTop: '3px', marginLeft: '-3px'}}
            alt={country.country}
          />
        </Box>
      </>
    );
  };

  const handleChange = (event: SelectChangeEvent<string>) => {
    const selectedValue = event.target.value;
    if (selectedValue) {
      const selectedCountry = JSON.parse(selectedValue) as CountryProps;
      onChange(selectedCountry);
    }
  };

  return (
      <Select
        labelId="country-select-label"
        id="country-select"
        value={value ? JSON.stringify(value) : ''}
        onChange={handleChange}
        renderValue={renderValue}
        className={`projectSelector ${mode}`}
        MenuProps={{ disableScrollLock: true }}
        sx={{ height: '30px', width: '40px'}}
        IconComponent={() => null}
      >
        {countries.map((country) => (
          <MenuItem key={`${country.country}${country.language}`} value={JSON.stringify(country)} >
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%'
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <img
                  src={`https://flagcdn.com/${country.country.toLowerCase()}.svg`}
                  alt={t(`country.${country.country}`)}
                  width={width}
                  style={{ marginRight: '10px' }}
                />
                {t(`country.${country.country}`)}
              </Box>
              <Typography
                variant="caption"
                sx={{ color: 'text.secondary', ml: 2 }}
              >
                {t(`language.${country.language}`)}
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
  );
};

export default FlagSelector;